import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TextField } from "../../../../components/forms/text";
import { socialIconMap } from "../../../../components/icons/social";
import { Flex } from "../../../../components/layout";
import { SocialMediaEnum } from "../../../../store/crypto/models/internal";
import { mapObject } from "../../../../utils/utils";
import { Container, StyledWidget } from "./components";
import { useStepValidation } from "./step";

const Logo = styled.div`
  height: auto;
  width: 2em;
  margin-right: 2em;
`;

const StyledFlex = styled(Flex)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

export const SocialMedia: React.FunctionComponent<{}> = () => {
  const { setValue, getValues } = useStepValidation(["socialMedia"]);
  const { control, watch } = useForm<Record<typeof SocialMediaEnum.T, string>>({
    defaultValues: getValues("socialMedia").reduce(
      (acc, curr) => ({ ...acc, [curr.type]: curr.value }),
      {}
    ),
  });

  const { t } = useTranslation("blockchain-tools");

  useEffect(() => {
    const subscription = watch((data) => {
      setValue(
        "socialMedia",
        mapObject(SocialMediaEnum.enum, (val, key) => ({
          type: key,
          value: data[key],
        }))
          .filter(({ value }) => value !== "" && value !== undefined)
          .map((x) => x as { type: typeof SocialMediaEnum.T; value: string })
      );
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <Container>
      <StyledWidget title={t("social-media-groups")}>
        {mapObject(SocialMediaEnum.enum, (val, key) => (
          <StyledFlex key={key}>
            <Logo as={socialIconMap[key]} />
            <Controller
              control={control}
              name={key}
              defaultValue=""
              render={({ field }) => (
                <TextField fullWidth label={val} {...field} />
              )}
            />
          </StyledFlex>
        ))}
      </StyledWidget>
    </Container>
  );
};
